import { ODataModel, ODataObject } from '../../interfaces/odata-model.interface';
import { ModelOptions } from '../options/model-options';

/**
 * This class should be used as base class for all other primitive models
 */
export abstract class PrimitiveModel implements ODataModel {
    public constructor(
        public name: string,
        public value: unknown,
        public options: ModelOptions,
    ) {}

    /**
     * Convert the internal data into an object suitable for OData exchange with SAP
     * Overwrite this method to do conversions as needed.
     *
     * @returns {object} an object with 'name' as key and the value converted into a format suitable for SAP
     */
    public getOutModel(): ODataPrimitiveOutModel {
        const outModel: ODataPrimitiveOutModel = {};

        outModel[this.name] = this.value ? this.value.toString() : '';

        return outModel;
    }
}

// need here type because empty interfaces are not allowed
export type ODataPrimitiveOutModel = ODataObject;
